import { createRouter, createWebHistory } from 'vue-router'
import { AuthRoutes } from '@/router/auth'
import { VocabRoutes } from '@/router/vocab'
import { ExamRoutes } from '@/router/exam-routes'
import { ProfileRoutes } from '@/router/profile-routes'
import { CourseRoutes } from '@/router/course-routes'
import { CancelContractRoutes } from '@/router/cancel-contract'
import { PaymentRoutes } from './payement'
import { authGuard } from './guards'
import { deviceDetect } from './device-detect'
import { ChatRoutes } from './chat-routes'
import { getSocket } from '@/services/socket'
import { PlacementRoutes } from './placement-routes'
import { LessonRoutes } from '@/router/lesson'
import { UserRoutes } from '@/router/user'
import { useBreadcrumbStore } from '@/stores/breadcrumb'
import { SettingsRoutes } from './setting'
import { NotificationRoutes } from './notifications'
import { TeacherRoutes } from './teacher-routes'
import { StoryRoutes } from './story-routes'
import { installPageTitles } from './page-title'
// import { NewRoutes } from './new-design'

const router = createRouter({
  strict: true,
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    ...AuthRoutes,
    ...ExamRoutes,
    ...ProfileRoutes,
    ...PaymentRoutes,
    ...CourseRoutes,
    ...CancelContractRoutes,
    ...ChatRoutes,
    ...PlacementRoutes,
    ...LessonRoutes,
    ...UserRoutes,
    ...SettingsRoutes,
    ...NotificationRoutes,
    ...TeacherRoutes,
    ...StoryRoutes,
    ...VocabRoutes,
    {
      path: '/account-deletion/result',
      name: 'account-deletion-result',
      component: () => import('@/views/auth/account-deletion-result.vue'),
      meta: { requiresAuth: false }
    },
    // ...NewRoutes, // Temporarily disabled: /new/home and /new/select-language
    {
      name: 'NotFound',
      path: '/:pathMatch(.*)*',
      component: () => import('@/views/error/not-found/index.vue')
    },
    {
      name: 'ServerError',
      path: '/server-error',
      component: () => import('@/views/error/server-error/index.vue')
    },
    {
      path: '/premium-activation',
      name: 'premium-activation',
      component: () => import('@/views/auth/premium-activation.vue')
    },
    {
      name: 'practice',
      path: '/practice',
      component: () => import('@/views/practice/index.vue')
    }
  ]
})

installPageTitles(router)

router.beforeEach(authGuard)
router.beforeEach(deviceDetect)
router.beforeEach((to, from, next) => {
  if (to.name === 'chat-app') {
    const socket = getSocket()
    if (socket && !socket.connected) {
      socket.connect()
    }
  }
  next()
})

router.beforeEach((to) => {
  const breadcrumbStore = useBreadcrumbStore()

  if (typeof to.meta.breadcrumb === 'function') {
    breadcrumbStore.setItems(to.meta.breadcrumb(to))
  } else if (Array.isArray(to.meta.breadcrumb)) {
    breadcrumbStore.setItems(to.meta.breadcrumb)
  } else {
    // Default breadcrumb if none specified
    // breadcrumbStore.setItems([
    //   { text: 'Home', to: '/' },
    //   { text: to.name?.toString() || to.path }
    // ])
  }
})

export default router

// Extend meta fields for proper typing
declare module 'vue-router' {
  interface RouteMeta {
    requiresAuth?: boolean
    requiresPlanAccess?: boolean
    isAuthRoute?: boolean
  }
}
